import React, {useEffect, useState} from "react";
import {
    Autocomplete, Box,
    Button,
    FormControlLabel,
    Stack,
    Switch,
    TextField
} from "@mui/material";
import FunctionsConfig from "../../Functions/FunctionsConfig";
import ShowConfirmationDialog from "../../Components/ShowConfirmationDialog";
import {LanguageConfig} from "../../Functions/LanguageConfig";

export default function AnimalSingleForm({rowBase, animals, setAnimals, community, currentAnimal, setCurrentAnimal, setBlocked,removeAnimal,frmEmail, microchipOnly} ) {

    const [row,setRow] = useState(rowBase)
    const [nme, setNme] = useState(row.name || '');
    const [primaryColor, setPrimaryColor] = useState(row.a_color_primary || '');
    const [secondaryColor, setSecondaryColor] = useState(row.a_color_secondary || '');
    const [frmAge, setFrmAge] = useState(row.age || '');
    const [frmGender, setFrmGender] = useState(row.gender || '');
    const [frmSource, setFrmSource] = useState(row.a_source || '');

    const [frmMicrochipOnly, setFrmMicrochipOnly] = useState(false);
    const [frmMicrochipped, setFrmMicrochipped] = useState((row.a_microchipped > 0) || false);
    const [frmPregnant, setFrmPregnant] = useState((row.a_is_pregnant > 0) || false);
    const [frmRecentPregnant, setFrmRecentPregnant] = useState((row.a_was_pregnant > 0) || false);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showNotificationColony, setShowNotificationColony] = useState(false);

    const [coloursPrimary, setColoursPrimary] = useState([]);
    const [coloursSecondary, setColoursSecondary] = useState([]);
    const [animalTypes, setAnimalTypes] = useState([]);
    const [weights, setWeights] = useState([]);
    const [sources, setSources] = useState([]);

    useEffect(() => {

        console.log("sadasdasdasdasdas dasdasdasdasdasdasdasd")
        FunctionsConfig.getPrimaryColours(row.animal_type).then((r) => {
            setColoursPrimary(r);
        });

        FunctionsConfig.getSecondaryColours(row.animal_type).then((r) => {
            setColoursSecondary(r);
        })

        if(community) {
            FunctionsConfig.getAnimalTypesArray('species-community').then((r) => {
                setAnimalTypes(r);
            })
        }else{
            FunctionsConfig.getAnimalTypesArray().then((r) => {
                setAnimalTypes(r);
            })
        }


        FunctionsConfig.getWeights().then((r) => {
            setWeights(r);
        })

        FunctionsConfig.getReasonsSource(row.animal_type).then((r) => {
            setSources(r);
        })

    },[row]);

    useEffect(() => {
        if(frmPregnant === true) {
            setFrmRecentPregnant(false);
        }
    }, [frmPregnant]);


    useEffect(() => {
        if(frmRecentPregnant === true) {
            setFrmPregnant(false);
        }
    }, [frmRecentPregnant]);

    useEffect(() => {

        try {

            if(showConfirmation || showNotificationColony) {
                // Skip validation/blocking updates while popup is open
                return;
            }

            if (
                (row.animal_type && String(row.animal_type).trim() !== '') &&
                (row.animal_type === "Rabbit" || (frmAge && frmAge !== '' && frmAge !== 'null')) &&
                frmSource && frmSource.trim() !== '' && frmSource !== 'null' &&
                (row.animal_type === "Rabbit" || (frmGender && frmGender !== '' && frmGender !== 'null')) &&
                (row.animal_type === "Rabbit" || (primaryColor && primaryColor !== '' && primaryColor !== 'null')) &&
                (row.animal_type !== "Dog" || (row.a_weight && row.a_weight !== '' && row.a_weight !== 'null')) &&
                !(nme === '' || !nme)
            ) {
                setBlocked(false);
            } else {
                setBlocked(true);
            }
        } catch (e) {

        }
    }, [frmAge,frmSource,frmGender,primaryColor,row,showConfirmation,showNotificationColony])

    function updateValue(val, col) {
        let v = val;
        let arr = animals;

        for (let x in arr) {
            if(arr[x].id === row.id) {
                arr[x][col] = val;
                if(col === 'animal_type') {
                    arr[x]['a_source'] = '';
                }
            }
        }

        setRow({...row,[col]:val});
        setAnimals(arr);
    }

    if(currentAnimal !== row.id) return (
        <div className={"animal-selected-box-collapsed"}>
            <p><strong>{row.name}</strong>, Type: {row.animal_type}, Sex: {(row.gender ==='') ? "n/a" : row.gender}
                <Button
                    variant={""}
                    sx={{boxShadow:'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px'}}
                    onClick={(e) => {e.preventDefault(); setCurrentAnimal(row.id)}}
                    style={{marginLeft: 10, fontSize:10}}
                >
                    {LanguageConfig["animalForm.Change.label"]}
                </Button>
                <Button
                    variant={""}
                    sx={{boxShadow:'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px'}}
                    onClick={(e) => {
                        e.preventDefault();
                        removeAnimal(row.id, row.voucher)}
                    }
                    style={{marginLeft: 10, fontSize:10}}
                >
                    {LanguageConfig["animalForm.Remove.label"]}
                </Button>
            </p>

        </div>
    );

    return (
        <div className={"animal-selected-box"} style={{marginTop:20}}>
            <Box component="form">
                <div>
                    <TextField
                        error={(nme==='' || nme ===  null)}
                        id="nme"
                        size={"full"}
                        value={nme}
                        label={(community) ? LanguageConfig["animalForm.name.labelCommunity"] : LanguageConfig["animalForm.name.label"]}
                        onBlur={
                            (e) => {
                                updateValue(e.target.value, 'name');
                                setNme(e.target.value);
                            }
                        }
                        onChange={(e) => {
                            setNme(e.target.value);
                        }}
                        sx={{ m: 1, width:'calc(100% - 20px)' }}
                    />

                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        sx={{m:1, marginBottom:2}}>
                        <Autocomplete
                            disableClearable
                            id="from-type"
                            size={"full"}
                            value={row.animal_type}
                            options={animalTypes}
                            sx={{ width:'100%'}}
                            renderInput={(params) => <TextField {...params} label="Type" error={( !row.animal_type || row.animal_type==='')} />}
                            onChange={(e,v) => {
                                if(String(v).trim() !== '') {
                                    updateValue(v, 'animal_type');
                                }
                            }}
                        />

                        <Autocomplete
                            disableClearable
                            size={"full"}
                            value={frmSource}
                            options={sources}
                            sx={{ width:'100%'}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           label={LanguageConfig["animalForm.a_source.label"]}
                                           error={( !frmSource || frmSource==='')}
                                />}
                            onChange={(e,v) => {
                                let setRequired = FunctionsConfig.getReasonsSourceRequireConfirmation();
                                let setNeedNotification = FunctionsConfig.getReasonsSourceRequireNotification();
                                if(setRequired.indexOf(v) > -1) {
                                    setFrmSource(v);
                                    updateValue(v, 'a_source');
                                    setShowConfirmation(true);
                                }else if(setNeedNotification.indexOf(v) > -1) {
                                    setFrmSource(v);
                                    updateValue(v, 'a_source');
                                    setShowNotificationColony(true);
                                }else{
                                    setFrmSource(v);
                                    updateValue(v, 'a_source');
                                }

                            }}
                        />
                        {
                            (showConfirmation === true) ?
                                <ShowConfirmationDialog open={showConfirmation} setOpen={setShowConfirmation}
                                                        header={"X"}
                                                        message={
                                                            <>
                                                                <p>
                                                                    Thank you for selecting <b>{frmSource}</b>. By ticking this box and completing the voucher process you are confirming that:
                                                                </p>
                                                                <ul style={{margin:'20px'}}>
                                                                    <li>You have permission from the owner of this animal to complete the voucher process.</li>
                                                                    {
                                                                        (community)  ?
                                                                            <li>The owner is aware that their name and contact details will be given to the Veterinary Clinic performing the surgery. The microchip will then be registered to the owner on the New Zealand Companion Animal Database.</li>
                                                                            :
                                                                            <li>You agree to give the name and contact details of the owner to the Veterinary Clinic performing the surgery. The microchip will then be registered to the owner on the New Zealand Companion Animal Database.</li>
                                                                    }
                                                                </ul>
                                                            </>
                                                        }
                                                        textConfirm={"I have read and agree to the above."}
                                                        textConfirmSet={frmEmail}
                                                        confirm
                                                        setFrmSource={setFrmSource}
                                                        frmSource={frmSource}
                                                        frmEmail={frmEmail}
                                                        frmSn={row.voucher}
                                                        checkboxAccept
                                />
                                : undefined
                        }
                        {
                            (showNotificationColony === true) ?
                                <ShowConfirmationDialog open={showNotificationColony} setOpen={setShowNotificationColony}
                                                        header={"X"}
                                                        message={
                                                            <>
                                                                <p>
                                                                    Thank you for selecting <b>{frmSource}</b>. By ticking this box and completing the voucher process you are confirming that:
                                                                </p>
                                                                {
                                                                    (community) ?
                                                                        <ul style={{margin:'20px'}}>
                                                                            <li>You have spoken to the member of public and they have confirmed that they have tried to find an owner, and to the best of their knowledge this animal does not belong to another person.</li>
                                                                            <li>The member of public is aware that if an owner is found, ownership remains with that original owner.</li>
                                                                            <li>The member of public has agreed to provide the current care that they do for this animal and agrees to look after this animals ongoing welfare needs, including if it becomes sick or injured.</li>
                                                                        </ul>
                                                                        :
                                                                        <ul style={{margin:'20px'}}>
                                                                            <li>You have tried to find an owner and to the best of your knowledge this animal does not belong to another person.</li>
                                                                            <li>If an owner is found, the ownership of this animal remains with that person.</li>
                                                                            <li>You will continue to provide the current care you do. In addition, you agree to look after this animal’s ongoing welfare needs, including if it becomes sick or injured.</li>
                                                                        </ul>
                                                                }
                                                            </>
                                                        }
                                                        textConfirm={
                                                            (community) ?
                                                                "I confirm that the member of public has been advised of the above terms and has agreed to them"
                                                                :
                                                                "I have read and agree to the above."
                                                        }
                                                        textConfirmSet={frmEmail}
                                                        confirm
                                                        setFrmSource={setFrmSource}
                                                        frmSource={frmSource}
                                                        frmEmail={frmEmail}
                                                        frmSn={row.voucher}
                                                        checkboxAccept
                                />
                                : undefined
                        }
                    </Stack>

                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        sx={{m:1, marginBottom:2}}
                    >
                        <Autocomplete
                            disableClearable
                            size={"full"}
                            value={frmGender}
                            id="frmGender"
                            options={FunctionsConfig.getGenders()}
                            sx={{ width:'100%',display:(row.animal_type === 'Rabbit') ? 'none' : null }}
                            renderInput={(params) =>
                                <TextField {...params}
                                           label="Sex"
                                           error={(!frmGender || frmGender==='')}
                                />}
                            onChange={(e,v) => {
                                //console.log('autocomplete',v)
                                setFrmGender(v);
                                updateValue(v, 'gender')
                            }}
                        />

                        <Autocomplete
                            disableClearable
                            size={"full"}
                            value={frmAge}
                            id="frmAge"
                            options={FunctionsConfig.getAges()}
                            sx={{ width:'100%',display:(row.animal_type === 'Rabbit') ? 'none' : null }}
                            renderInput={(params) =>
                                <TextField
                                    error={(!frmAge || frmAge==='')}
                                    {...params}
                                    label="Age of your animal"
                                />
                            }
                            onChange={(e,v) => {
                                setFrmAge(v);
                                updateValue(v, 'age')
                            }}
                        />
                    </Stack>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        sx={{m:1, marginBottom:2,display:(row.animal_type === 'Rabbit') ? 'none' : null}}
                    >
                        <Autocomplete
                            disableClearable
                            error={primaryColor === ''}
                            size={"full"}
                            value={primaryColor}
                            id="combo-primaryColor"
                            options={coloursPrimary}
                            sx={{width: '100%'}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           error={primaryColor === '' || primaryColor === null || primaryColor === 'Unknown'}
                                           label={LanguageConfig["animalForm.a_color_primary.label"]} />
                            }
                            onChange={(e, v) => {
                                setPrimaryColor(v);
                                updateValue(v, 'a_color_primary');
                                return false;
                            }}
                        />
                        <Autocomplete
                            disableClearable
                            error={primaryColor === ''}
                            size={"full"}
                            value={secondaryColor}
                            id="combo-primaryColor"
                            options={coloursSecondary}
                            sx={{width: '100%'}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           label={LanguageConfig["animalForm.a_color_secondary.label"]}/>
                            }
                            onChange={(e, v) => {
                                setSecondaryColor(v);
                                updateValue(v, 'a_color_secondary');
                                return false;
                            }}
                        />
                    </Stack>

                    <ShowWeightAddon row={row} setRow={setRow} weights={weights} LanguageConfig={LanguageConfig} updateValue={updateValue} />

                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        sx={{m:1,display:(['Rabbit','Dog'].includes(row.a_type)) ? 'none' : null }}
                    >
                        <FormControlLabel control={<Switch checked={frmMicrochipped} onChange={(e) => {
                            setFrmMicrochipped(e.target.checked);
                            updateValue(e.target.checked, 'is_microchipped');
                        }} />} size={"small"}  label={LanguageConfig["animalForm.is_microchipped.label"]} />
                        <FormControlLabel control={<Switch checked={frmPregnant} onChange={(e) => {
                            setFrmPregnant(e.target.checked);
                            updateValue(e.target.checked, 'is_pregnant');
                        }} />} size={"small"} label={LanguageConfig["animalForm.is_pregnant.label"]} />
                        <FormControlLabel control={<Switch checked={frmRecentPregnant} onChange={(e) => {
                            setFrmRecentPregnant(e.target.checked);
                            updateValue(e.target.checked, 'was_pregnant');
                        }} />} size={"small"} label={LanguageConfig["animalForm.was_pregnant.label"]} />
                    </Stack>

                    <Stack>
                        <FormControlLabel control={<Switch disabled={microchipOnly === true} checked={microchipOnly ? true : frmMicrochipOnly} onChange={(e) => {
                            setFrmMicrochipOnly(e.target.checked);
                            updateValue(e.target.checked ? 1 : 0, 'a_microchip_only_flag');
                        }} />} size={"small"} style={{marginBottom:20}}  label={"Microchip only, no desexing required"} />
                    </Stack>

                    <Button
                        variant={""}
                        sx={{boxShadow:'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px'}}
                        onClick={(e) => {
                            e.preventDefault();
                            removeAnimal(row.id, row.voucher)}
                        }
                        style={{marginLeft: 0, marginBottom:20, fontSize:10}}
                    >
                        {LanguageConfig["animalForm.Remove.label"]}
                    </Button>
                </div>
            </Box>
        </div>
    )
}

const ShowWeightAddon = ({updateValue,row,setRow,weights}) => {

    // useEffect(() => {
    //     setRow(row);
    // }, [row]);


    if(row.animal_type !== 'Dog') return null;
    return (
        <Autocomplete
            disableClearable
            size={"full"}
            value={row.a_weight}
            id="combo-weight"
            options={weights}
            sx={{width: 'calc(100% - 15px)',margin:1}}
            renderInput={(params) =>
                <TextField {...params}
                           error={!row.a_weight  || row.a_weight === '' || row.a_weight === null}
                           label={LanguageConfig["animalForm.a_weight.label"]}
                />
            }
            onChange={(e, v) => {
                updateValue(v, 'a_weight');
                return false;
            }}
        />
    )
}
